import { usePassengerCount } from "@website/ticket-ui/common/components/passenger-count-old/hook";
import { PassengerCountPropertiesType } from "@website/ticket-ui/common/components/passenger-count-old/types";
import { Button } from "@website/ui-old/button";
import { Chips } from "@website/ui-old/chips";
import { ListItem } from "@website/ui-old/list-item";
import { MiniPopover } from "@website/ui-old/mini-popover";
import pick from "lodash-es/pick";
import { FC } from "react";

export const PassengerCountOld: FC<PassengerCountPropertiesType> = (
  properties
) => {
  const { list, chipsProps, popoverProps, submitButtonProps, submitText } =
    usePassengerCount(properties);

  return (
    <div className="relative">
      {properties?.attached ? (
        <div className="cursor-pointer" {...pick(chipsProps, "onClick")}>
          <div className="text-body-2 text-on-surface-medium-emphasis flex items-center gap-1">
            <div>نفرات</div>
            {chipsProps?.EndIcon}
          </div>
          <div className="text-subtitle-1 text-on-surface-medium-emphasis pt-1">
            {chipsProps.text}
          </div>
        </div>
      ) : (
        <Chips {...chipsProps} />
      )}

      <MiniPopover {...popoverProps}>
        <div className="flex flex-1 flex-col overflow-hidden">
          <div className="flex flex-1 overflow-hidden">
            <div className="flex-1 overflow-y-auto">
              {list.map((item) => (
                <ListItem key={item.title} {...item} />
              ))}
            </div>
          </div>
          <div className="border-t px-6 pb-6 pt-4">
            <Button {...submitButtonProps}>{submitText}</Button>
          </div>
        </div>
      </MiniPopover>
    </div>
  );
};
